export const videoController = (function ($) {

    const $button = $(".js-play-video");
    const $video = $("video");

    function init() {

        // addto  play button class if video is autoplay
        if ($video.length > 0 && $video[0].hasAttribute("autoplay")) {
            $button.addClass("play-button--video-autoplay");
        }

        $button.on("click", function () {
            // the button should be inserted after <video> tag for this to work
            let $mediaVideo = $(this).prev("video")[0];
            if ($mediaVideo.paused) {
                $mediaVideo.play();
            } else {
                $mediaVideo.pause();
            }
            $(this).toggleClass("is-playing")
        });

    }

    return {
        init: init
    }

})(jQuery);
